import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'

import Button from '../../../components/BaseUI/Button'
import Content from '../Content'

import styles from './VerifyEmail.module.scss'
import { useTitle } from '../../../hooks/useTitle'

const API_URL =
  process.env.REACT_APP_API_URL || 'https://dm.aibuddyassistant.com/api'

export default function VerifyEmail() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  useTitle('Подтверждение Email | AIBuddy CRM')

  const [status, setStatus] = useState('loading') // loading, success, error, already_verified
  const [message, setMessage] = useState('')

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error')
        setMessage('Ссылка для подтверждения недействительна.')
        return
      }

      try {
        const response = await axios.get(
          `${API_URL}/auth/verify-email/${token}`
        )

        if (response.data.alreadyVerified) {
          setStatus('already_verified')
          setMessage('Ваш email уже подтвержден.')
        } else {
          setStatus('success')
          setMessage('Email успешно подтвержден!')
        }
      } catch (error) {
        setStatus('error')
        setMessage(error.response?.data?.error || 'Ошибка подтверждения email.')
      }
    }

    verifyEmail()
  }, [token])

  const getIcon = () => {
    switch (status) {
      case 'loading':
        return (
          <div className={styles.spinner}>
            <div className={styles.loader}></div>
          </div>
        )
      case 'success':
      case 'already_verified':
        return (
          <div className={styles.iconSuccess}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        )
      case 'error':
        return (
          <div className={styles.iconError}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        )
      default:
        return null
    }
  }

  const getTitle = () => {
    switch (status) {
      case 'loading':
        return 'Подтверждение email...'
      case 'success':
        return 'Email подтвержден!'
      case 'already_verified':
        return 'Email уже подтвержден'
      case 'error':
        return 'Ошибка подтверждения'
      default:
        return ''
    }
  }

  return (
    <div className={styles['verify-container']}>
      <Content title={getTitle()}>
        <div className={styles.content}>
          {getIcon()}
          <p className={styles.message}>{message}</p>

          {status === 'loading' && (
            <p className={styles.hint}>Пожалуйста, подождите...</p>
          )}

          {(status === 'success' || status === 'already_verified') && (
            <div className={styles.actions}>
              <Button
                title="Перейти в личный кабинет"
                appearance="primary"
                isBlock={true}
                onClick={() => navigate('/dashboard', { replace: true })}
              />
            </div>
          )}

          {status === 'error' && (
            <div className={styles.actions}>
              <Button
                title="Войти в систему"
                appearance="primary"
                isBlock={true}
                onClick={() => navigate('/login', { replace: true })}
              />
              <div className={styles.divider}></div>
              <Button
                title="Запросить новую ссылку"
                appearance="secondary"
                isBlock={true}
                onClick={() =>
                  navigate('/resend-verification', { replace: true })
                }
              />
            </div>
          )}
        </div>
      </Content>
    </div>
  )
}
